// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"66634a82","81":"158940f7","437":"955ce981","453":"54292a4b"}[chunkId] + ".chunk.js";
};